module.exports = __webpack_public_path__ + "img/zm_tuwen@3x.97001ef8.png";